// Display tempo for the song header: median of per-bar tempos (robust to a stray long/short bar),
// falling back to the analysis BPM. Same formula the old alphaTex header used.
import type { ChartMeasure } from "../../types/domain";

export function headerTempo(measures: ChartMeasure[], analysisBpm: number): number {
  const perBar: number[] = [];
  for (const m of measures) {
    const dur = m.endTime - m.startTime;
    if (dur > 0.05 && m.beats.length) perBar.push(Math.round((60 * m.beats.length) / dur));
  }
  perBar.sort((a, b) => a - b);
  return perBar.length ? perBar[Math.floor(perBar.length / 2)] : Math.round(analysisBpm || 120);
}
